import yup from 'src/libs/yup';

export const MediaStoreSchema = yup.object().shape({
  name: yup.string().max(255).required().label('Nome'),
  file: yup.mixed().isFile().required().label('Arquivo'),
});

export const MediaUpdateSchema = yup.object().shape({
  name: yup.string().max(255).required().label('Nome'),
  file: yup.mixed().isFile().label('Arquivo'),
});
